import React, { Component } from "react";
import { connect } from "react-redux";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { setRemainingTime, nextExam } from "./../actions/assessment";

import AgreeDisagree from "./qtemplate/AgreeDisagree";
import ImageComparison from "./qtemplate/ImageComparison";
import MultipleChoiceWithImageQuestion from "./qtemplate/MultipleChoiceWithImageQuestion";
import MutipleChoiceText from "./qtemplate/MutipleChoiceText";
import TwoChoiceCompare from "./qtemplate/TwoChoiceCompare";
import ReadingComprehension from "./qtemplate/ReadingComprehension";
import MultipleChoiceImageWithImageQuestion from "./qtemplate/MultipleChoiceImageWithImageQuestion";

import { SaveUserStateToServerHelper } from "./Helper";

import config from "./../config/config-secret.json";

export class Examination extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  AGREE_DISAGREE = 1;
  IMAGE_COMPARISON = 2;
  MULTIPLE_CHOICE_TEXT_WITH_QUESTION_IMAGE = 3;
  MULTIPLE_CHOICE_TEXT = 4;
  CHOICE_COMPARE = 5;
  READING_COMPREHENSION = 6;
  MULTIPLE_CHOICE_IMAGE_WITH_QUESTION_IMAGE = 7;

  render() {
    let questionImage1 = this.props.question.image1;
    let questionImage2 = this.props.question.image2;

    if (questionImage1 !== null) {
      questionImage1 = config.API_DOMAIN + this.props.question.image1;
    }
    if (questionImage2 !== null) {
      questionImage2 = config.API_DOMAIN + this.props.question.image2;
    }

    return (
      <div className="main container-fluid h-100">
        <div className="row justify-content-center align-items-center">
          <div className="col-12">
            <div className="container">
              <TransitionGroup className="card-container">
                <CSSTransition
                  key={this.props.question.id}
                  timeout={500}
                  classNames="fade"
                >
                  <div
                    className="test"
                    style={{
                      userSelect: "none",
                      WebkitUserSelect: "none",
                      MozUserSelect: "none",
                      msUserSelect: "none",
                    }}
                  >
                    {this.props.question.type === this.AGREE_DISAGREE && (
                      <AgreeDisagree
                        question_id={this.props.question.id}
                        questiontext={this.props.question.text}
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type === this.IMAGE_COMPARISON && (
                      <ImageComparison
                        question_id={this.props.question.id}
                        questionimage={
                          config.API_DOMAIN + this.props.question.image1
                        }
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type ===
                      this.MULTIPLE_CHOICE_TEXT_WITH_QUESTION_IMAGE && (
                      <MultipleChoiceWithImageQuestion
                        question_id={this.props.question.id}
                        questiontext={this.props.question.text}
                        questionimage1={questionImage1}
                        questionimage1_pos={this.props.question.image1_position}
                        questionimage2={questionImage2}
                        questionimage2_pos={this.props.question.image2_position}
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type === this.MULTIPLE_CHOICE_TEXT && (
                      <MutipleChoiceText
                        question_id={this.props.question.id}
                        questiontext={this.props.question.text}
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type === this.CHOICE_COMPARE && (
                      <TwoChoiceCompare
                        question_id={this.props.question.id}
                        compare_text1={this.props.question.compare_text1}
                        compare_text2={this.props.question.compare_text2}
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type ===
                      this.READING_COMPREHENSION && (
                      <ReadingComprehension
                        context={
                          this.props.question.reading_comprehension_context
                        }
                        question_id={this.props.question.id}
                        questiontext={this.props.question.text}
                        choices={this.props.question.question_choices}
                      />
                    )}
                    {this.props.question.type ===
                      this.MULTIPLE_CHOICE_IMAGE_WITH_QUESTION_IMAGE && (
                      <MultipleChoiceImageWithImageQuestion
                        question_id={this.props.question.id}
                        questiontext={this.props.question.text}
                        questionimage1={questionImage1}
                        questionimage2={questionImage2}
                        choices={this.props.question.question_choices}
                      />
                    )}
                  </div>
                </CSSTransition>
              </TransitionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  question:
    state.assessment.exams[state.assessment.exam_index].questions[
      state.assessment.question_index
    ],
});

const mapDispatchToProps = (dispatch) => ({
  nextExam: () => dispatch(nextExam()),
  setRemainingTime: () => dispatch(setRemainingTime()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Examination);
